<template>
  <div>
    <div class="card exchange-history-card" v-if="isDesktop">
      <div class="card-body">
        <div class="wallet-history">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="transfer-date-column">{{ labels.timestamp }}</th>
                  <th class="transfer-center-column">{{ labels.type }}</th>
                  <th class="transfer-center-column">{{ labels.code }}</th>
                  <th class="transfer-name-column">{{ labels.name }}</th>
                  <th class="transfer-center-column">{{ labels.exchange }}</th>
                  <th class="transfer-number-column">{{ labels.quantity }}</th>
                  <th class="transfer-center-column">{{ labels.segment }}</th>
                  <th class="transfer-number-column">{{ labels.price }}</th>
                  <th class="transfer-number-column">{{ labels.totalAmount }}</th>
                  <th class="transfer-action-column"></th>
                </tr>
              </thead>
              <tbody>
                <tr class="center-vertical" v-for="(transfer, index) in transfers" :key="index">
                  <td class="transfer-date-column">{{ dateResolver(transfer?.ts) }}</td>
                  <td class="transfer-center-column">{{ capitalizeFirstLetter(transferTypeResolver(transfer?.tt)) }}</td>
                  <td class="transfer-center-column">{{ transfer?.sc?.toUpperCase() }}</td>
                  <td class="transfer-name-column">
                    <div v-if="isBulgarian">{{ transfer?.nBG ? transfer?.nBG : transfer?.nEN }}</div>
                    <div v-if="isEnglish">{{ transfer?.nEN }}</div>
                  </td>
                  <td class="transfer-center-column">{{ transfer?.xc?.toUpperCase() }}</td>
                  <td class="transfer-number-column">{{ parseNumber(transfer?.qty, 0) }}</td>
                  <td class="transfer-center-column">{{ transfer?.sgm?.toUpperCase() }}</td>
                  <td v-if="transfer?.stid !== 2" class="transfer-number-column">
                    {{ formatPrice(transfer?.sp, transfer?.cc, 4).replace(" ", "&nbsp;") }}
                  </td>
                  <td v-else class="transfer-number-column">
                    {{ formatPrice(transfer?.sp, "%").replace(" ", "&nbsp;") }}
                  </td>
                  <td class="transfer-number-column">
                    {{ formatPrice(transfer?.pt, transfer?.cc, 4).replace(" ", "&nbsp;") }}
                  </td>
                  <td class="transfer-action-column">
                    <div class="transfer-action-content">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click.prevent="$emit('open-transfer-details', transfer)"
                      >&rarr;</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else v-for="(transfer, index) in transfers" :key="index">
      <div class="card">
        <div class="card-body xsmall-font-size">
          <div class="container p-0">
            <div class="row justify-content-between">
              <div class="col-6">
                {{ dateResolver(transfer?.ts) }}<br />
                <strong>{{ transfer?.sc?.toUpperCase() }}@{{ transfer?.xc?.toUpperCase() }}</strong><br />
                {{ capitalizeFirstLetter(transferTypeResolver(transfer?.tt)) }}
              </div>
              <div class="col-6 text-end my-auto">
                <button
                  type="button"
                  class="btn btn-primary xsmall-font-size"
                  @click.prevent="$emit('open-transfer-details', transfer)"
                >&rarr;</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["open-transfer-details"],
  props: {
    transfers: { type: Array, required: true },
    windowWidth: { type: Number, required: true },
    userLanguage: { type: String, required: true },
    labels: { type: Object, required: true },
    dateResolver: { type: Function, required: true },
    transferTypeResolver: { type: Function, required: true },
    capitalizeFirstLetter: { type: Function, required: true },
    formatPrice: { type: Function, required: true },
    parseNumber: { type: Function, required: true }
  },
  computed: {
    isDesktop() {
      return 1200 < this.windowWidth;
    },
    isBulgarian() {
      return 0 === "BG".localeCompare(this.userLanguage);
    },
    isEnglish() {
      return 0 === "EN".localeCompare(this.userLanguage);
    }
  }
};
</script>

<style scoped>
.exchange-history-card {
  border: 0;
  box-shadow: none;
}

.exchange-history-card .card-body {
  padding: 0;
}

.wallet-history {
  border-top: 1px solid #f0f3fa;
}

.center-vertical,
.center-vertical > td {
  vertical-align: middle;
}

.transfer-date-column {
  text-align: left;
  width: 15%;
}

.transfer-center-column {
  text-align: center;
}

.transfer-name-column {
  text-align: left;
  width: 20%;
}

.transfer-number-column {
  text-align: right;
}

.transfer-action-column {
  text-align: center;
  width: 4rem;
}

td.transfer-action-column {
  vertical-align: middle;
}

.transfer-action-content {
  align-items: center;
  display: flex;
  justify-content: center;
}

.xsmall-font-size {
  font-size: x-small;
}
</style>
